import { Stack } from "@mui/material";
import { CircularLoader } from "components";
import { useGetTask, useGlobalStore } from "controller";
import { MqttContext } from "controller/context/MqttCreateContext";
import { useContext, useEffect } from "react";
import { statusData } from "shared/data";
import { Chat } from "shared/features/chat/Chat";
import type { ChatNotificationSchema, ChatResultItem } from "shared/types";

const disabledStatus: Array<string> = [statusData.CLOSED, statusData.CANCELLED];
export const TaskChatContainer = ({
  selectedChat,
  onClose,
  onFullscreenClick,
  onThreadClick,
}: {
  onClose: () => void;
  selectedChat: ChatNotificationSchema;
  onFullscreenClick?: () => void;
  onThreadClick?: (message: ChatResultItem) => void;
}) => {
  const { data: taskData, isLoading: isTaskApiLoading } = useGetTask(
    selectedChat.service_id,
  );

  const mspId = useGlobalStore((state) => state.mspId);
  const resourceId = useGlobalStore((state) => state.resourceId);
  const { subscribeRoom, isConnected, unSubscribeRoom } =
    useContext(MqttContext);

  useEffect(() => {
    if (!isConnected) return;

    const topics = [
      `${selectedChat.service_type}s/${mspId}/${selectedChat.service_id}`,
      `${selectedChat.service_type}s/${mspId}/${selectedChat.service_id}/private`,
      `${selectedChat.service_type}s/${mspId}/${selectedChat.service_id}/resource/${resourceId}`,
    ];
    subscribeRoom(topics);

    return () => {
      unSubscribeRoom(topics);
    };
  }, [isConnected, selectedChat.service_type, selectedChat.service_id, mspId, resourceId, subscribeRoom, unSubscribeRoom]);

  return isTaskApiLoading ? (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "white",
        borderRadius: "16px",
      }}
    >
      <CircularLoader />
    </Stack>
  ) : (
    <Chat
      isDisabled={disabledStatus.includes(selectedChat?.service_status)}
      serviceType={selectedChat.service_type as "task" | "ticket"}
      serviceId={selectedChat.service_id}
      section="messageBar"
      onClose={onClose}
      serviceSource={taskData?.source_name}
      onFullscreenClick={onFullscreenClick}
      onThreadClick={onThreadClick}
    />
  );
};
